import React from 'react';
import ChampionsLeagueAdminExtended from './ChampionsLeagueAdminExtended';
import './ChampionsLeagueAdminExtended.css';

const ChampionsLeagueAdmin = () => {
  return <ChampionsLeagueAdminExtended />;
};

ChampionsLeagueAdmin.displayName = 'ChampionsLeagueAdmin';

export default ChampionsLeagueAdmin;